import { ButtonProps, useModal } from "@homebound/beam";
import { disableBasedOnPotentialOperationText } from "src/routes/components/PotentialOperationsUtils";
import { UsePublishProductOffering_ProductOfferingFragment } from "src/routes/developments/product-offerings/components/usePublishProductOffering.generated";
import { PublishAggregateVersionModal } from "src/routes/libraries/plan-package-v2/components/PublishAggregateVersionModal";
import { fail } from "src/utils";

/** Publishes a product offering's draft. Owns the modal and the disabled state. */
export function usePublishProductOffering(productOffering: UsePublishProductOffering_ProductOfferingFragment): {
  disabled: ButtonProps["disabled"];
  onClick: () => void;
} {
  const { aggregateDraft } = productOffering;
  const { openModal } = useModal();
  return {
    disabled: publishDisabledReason(productOffering),
    onClick: () =>
      openModal({
        content: (
          <PublishAggregateVersionModal
            draftAggregateVersion={aggregateDraft ?? fail("No draft aggregate version found")}
            copyText="This update and version notes will be made available to any active projects that reference it."
            readyPlanName={productOffering.name}
            readyPlanId={productOffering.id}
            allowGenerateAiNotes
          />
        ),
      }),
  };
}

/** Why the offering's draft can't be published, or `false` if it can. Also gates bulk-publish row selection. */
export function publishDisabledReason(productOffering: UsePublishProductOffering_ProductOfferingFragment) {
  // `canPublish` only exists on the draft, so with no draft there's nothing to publish
  return productOffering.aggregateDraft
    ? disableBasedOnPotentialOperationText(productOffering.aggregateDraft.canPublish)
    : "The latest version has already been published";
}
